import { useEffect } from 'react';
import * as React from 'react';
import { observer } from 'mobx-react';
import SecuredPage from 'Views/Components/Security/SecuredPage';
import NavigationWrapper from 'Views/Components/Navigation/NavigationWrapper';
import { SecuredGroups } from 'Models/Security/UserGroups';
import UserDetailPage from 'Modules/UserAccount/Components/UserDetailPage';
import { ACCOUNT_STAFF_VIEW_PAGE_TITLE } from 'ConstantPageNames';

/**
 * The merged staff view of a user at /users/:id/:tab? — replaces the old /search-results/:id
 * and /staff-account-details/:id/:tab? pages (both now redirect here).
 */
function StaffUserDetailPage() {
	useEffect(() => {
		document.title = ACCOUNT_STAFF_VIEW_PAGE_TITLE;
	}, []);

	return (
		<SecuredPage groups={SecuredGroups.create.onlyStaff().groups}>
			<NavigationWrapper />
			<div className="body-content">
				<UserDetailPage />
			</div>
		</SecuredPage>
	);
}

export default observer(StaffUserDetailPage);
